
import slugify from 'slugify';
import { mapActions } from 'vuex';
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [uiMixin],
  props: {
    post: {
      required: true,
      type: Object,
      default: () => {},
    },
    isLoaded: {
      required: false,
      type: Boolean,
      default: true,
    },
  },

  methods: {
    ...mapActions('posts', ['loadSinglePost']),
    toBlogPost(id, title) {
      const slug = slugify(title, {
        lower: true,
        remove: /[*+~.()'"!:@]/g,
      });
      this.$router.push({
        path: `/blog/posts/${id}/${slug}`,
      });
      // this.loadSinglePost(id);
    },
  },
  computed: {
    profileImageFullUrl() {
      return this.$config.mrBaseUrl + this.post.user.profileImageURL;
    },
  },
};
